import React from 'react';

import { Box } from '@fhs-legacy/universal-components';

import { Body2, StoreCardViewContainer, Subtitle2 } from '../store-card.styled';
import { buildStoreCardDetailsAccessibilityLabel } from '../utils/build-store-card-details-accessibility-label';

import type { StoreCardDetailsProps } from './store-card-details.types';
import { StoreCardError } from './store-card-error';

export const StoreCardDetails: React.VFC<StoreCardDetailsProps> = ({
  body,
  caption,
  errorMessage,
  title,
  isSelected,
  availability,
  address,
  addressAccessibilityLabel,
}) => {
  const accessibilityLabel = buildStoreCardDetailsAccessibilityLabel({
    title,
    address,
    addressAccessibilityLabel,
    availability,
    body,
    errorMessage,
    isSelected,
  });
  const expanded = !!isSelected;

  return (
    <StoreCardViewContainer
      accessible
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      accessibilityState={{ expanded, selected: expanded }}
    >
      <Box style={{ width: '100%' }}>
        {title ? <Subtitle2>{title}</Subtitle2> : null}
        {address ? <Box>{address}</Box> : null}
        <Box flexDirection="row" alignItems="center">
          {caption}
        </Box>
        {body ? <Body2>{body}</Body2> : null}
        {errorMessage ? <StoreCardError message={errorMessage} /> : null}
      </Box>
    </StoreCardViewContainer>
  );
};
